import React, { useState, useMemo } from 'react';
import './Transactions.css';
import '../../components/Button/Button.css';
import { useLanguage } from '../../context/LanguageContext';
import { getTranslation } from '../../i18n/translations';

const Transactions = () => {
  const { language } = useLanguage();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Mock transaction data
  const mockTransactions = [
    {
      id: 1,
      externalKey: 'TX-2024-001',
      description: 'Cloud Mining Purchase',
      amount: '+$1,250.00',
      dateTime: '2024-01-15 14:30:00',
      comment: 'BTC Cloud Mining Contract'
    },
    {
      id: 2,
      externalKey: 'TX-2024-002',
      description: 'ASIC Purchase',
      amount: '-$4,650.00',
      dateTime: '2024-01-14 10:15:00',
      comment: 'Antminer S21 XP'
    },
    {
      id: 3,
      externalKey: 'TX-2024-003',
      description: 'Deposit',
      amount: '+$500.00',
      dateTime: '2024-01-13 16:45:00',
      comment: 'Bank Transfer'
    },
    {
      id: 4,
      externalKey: 'TX-2024-004',
      description: 'Withdrawal',
      amount: '-$200.00',
      dateTime: '2024-01-12 09:20:00',
      comment: 'BTC Withdrawal'
    },
    {
      id: 5,
      externalKey: 'TX-2024-005',
      description: 'Referral Bonus',
      amount: '+$50.00',
      dateTime: '2024-01-11 11:00:00',
      comment: 'Referral Commission'
    },
    {
      id: 6,
      externalKey: 'TX-2024-006',
      description: 'Cloud Mining Purchase',
      amount: '+$800.00',
      dateTime: '2024-01-10 13:30:00',
      comment: 'ETH Cloud Mining Contract'
    },
    {
      id: 7,
      externalKey: 'TX-2024-007',
      description: 'Hosting Fee',
      amount: '-$150.00',
      dateTime: '2024-01-09 08:00:00',
      comment: 'Monthly Hosting Fee'
    },
    {
      id: 8,
      externalKey: 'TX-2024-008',
      description: 'Deposit',
      amount: '+$1,000.00',
      dateTime: '2024-01-08 15:20:00',
      comment: 'Credit Card Payment'
    },
    {
      id: 9,
      externalKey: 'TX-2024-009',
      description: 'ASIC Purchase',
      amount: '-$3,200.00',
      dateTime: '2024-01-07 12:10:00',
      comment: 'Antminer S21 Pro'
    },
    {
      id: 10,
      externalKey: 'TX-2024-010',
      description: 'Mining Reward',
      amount: '+$75.50',
      dateTime: '2024-01-06 10:00:00',
      comment: 'Daily Mining Payout'
    },
    {
      id: 11,
      externalKey: 'TX-2024-011',
      description: 'Deposit',
      amount: '+$2,500.00',
      dateTime: '2024-01-05 14:45:00',
      comment: 'Crypto Deposit'
    },
    {
      id: 12,
      externalKey: 'TX-2024-012',
      description: 'Withdrawal',
      amount: '-$500.00',
      dateTime: '2024-01-04 11:30:00',
      comment: 'BTC Withdrawal'
    }
  ];

  const totalPages = Math.max(1, Math.ceil(mockTransactions.length / itemsPerPage));

  const paginatedTransactions = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return mockTransactions.slice(startIndex, endIndex);
  }, [currentPage, itemsPerPage]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleUploadToEmail = () => {
    // Simulate uploading transactions to email
    alert('All transactions will be sent to your email address.');
  };

  const handleWithdrawalGuide = () => {
    // Navigate to withdrawal guide
    console.log('Navigate to Withdrawal Guide');
  };

  const handleTotalSumTransactions = () => {
    // Navigate to total sum transactions
    console.log('Navigate to Total Sum Transactions');
  };

  return (
    <div className="transaction-container holder">
      <div className="transaction-title-block">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z"
            stroke="#1570EF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M18.0545 15.4545C17.9456 15.7013 17.9131 15.9751 17.9613 16.2405C18.0094 16.5059 18.1359 16.7508 18.3245 16.9436L18.3736 16.9927C18.5258 17.1447 18.6465 17.3252 18.7288 17.5238C18.8112 17.7225 18.8536 17.9354 18.8536 18.1505C18.8536 18.3655 18.8112 18.5784 18.7288 18.7771C18.6465 18.9757 18.5258 19.1562 18.3736 19.3082C18.2217 19.4603 18.0412 19.581 17.8425 19.6634C17.6439 19.7457 17.431 19.7881 17.2159 19.7881C17.0009 19.7881 16.7879 19.7457 16.5893 19.6634C16.3906 19.581 16.2102 19.4603 16.0582 19.3082L16.0091 19.2591C15.8163 19.0705 15.5714 18.9439 15.3059 18.8958C15.0405 18.8477 14.7668 18.8802 14.52 18.9891C14.278 19.0928 14.0716 19.265 13.9263 19.4845C13.7809 19.704 13.7029 19.9613 13.7018 20.2245V20.3636C13.7018 20.7976 13.5294 21.2138 13.2225 21.5207C12.9157 21.8276 12.4994 22 12.0655 22C11.6315 22 11.2152 21.8276 10.9084 21.5207C10.6015 21.2138 10.4291 20.7976 10.4291 20.3636V20.29C10.4228 20.0192 10.3351 19.7565 10.1775 19.5362C10.0199 19.3159 9.79969 19.1481 9.54545 19.0545C9.29868 18.9456 9.02493 18.9131 8.75952 18.9613C8.4941 19.0094 8.24919 19.1359 8.05636 19.3245L8.00727 19.3736C7.8553 19.5258 7.67483 19.6465 7.47617 19.7288C7.27752 19.8112 7.06459 19.8536 6.84955 19.8536C6.6345 19.8536 6.42157 19.8112 6.22292 19.7288C6.02426 19.6465 5.84379 19.5258 5.69182 19.3736C5.53967 19.2217 5.41898 19.0412 5.33663 18.8425C5.25428 18.6439 5.21189 18.431 5.21189 18.2159C5.21189 18.0009 5.25428 17.7879 5.33663 17.5893C5.41898 17.3906 5.53967 17.2102 5.69182 17.0582L5.74091 17.0091C5.92953 16.8163 6.05606 16.5714 6.10419 16.3059C6.15231 16.0405 6.11982 15.7668 6.01091 15.52C5.90719 15.278 5.73498 15.0716 5.51547 14.9263C5.29596 14.7809 5.03873 14.7029 4.77545 14.7018H4.63636C4.20237 14.7018 3.78616 14.5294 3.47928 14.2225C3.1724 13.9157 3 13.4994 3 13.0655C3 12.6315 3.1724 12.2152 3.47928 11.9084C3.78616 11.6015 4.20237 11.4291 4.63636 11.4291H4.71C4.98081 11.4228 5.24346 11.3351 5.46379 11.1775C5.68412 11.0199 5.85195 10.7997 5.94545 10.5455C6.05437 10.2987 6.08686 10.0249 6.03873 9.75952C5.99061 9.4941 5.86408 9.24919 5.67545 9.05636L5.62636 9.00727C5.47422 8.8553 5.35352 8.67483 5.27118 8.47617C5.18883 8.27752 5.14644 8.06459 5.14644 7.84955C5.14644 7.6345 5.18883 7.42157 5.27118 7.22292C5.35352 7.02426 5.47422 6.84379 5.62636 6.69182C5.77834 6.53967 5.95881 6.41898 6.15746 6.33663C6.35611 6.25428 6.56905 6.21189 6.78409 6.21189C6.99913 6.21189 7.21207 6.25428 7.41072 6.33663C7.60937 6.41898 7.78984 6.53967 7.94182 6.69182L7.99091 6.74091C8.18374 6.92953 8.42865 7.05606 8.69406 7.10419C8.95948 7.15231 9.23322 7.11982 9.48 7.01091H9.54545C9.78745 6.90719 9.99383 6.73498 10.1392 6.51547C10.2846 6.29596 10.3626 6.03873 10.3636 5.77545V5.63636C10.3636 5.20237 10.536 4.78616 10.8429 4.47928C11.1498 4.1724 11.566 4 12 4C12.434 4 12.8502 4.1724 13.1571 4.47928C13.464 4.78616 13.6364 5.20237 13.6364 5.63636V5.71C13.6374 5.97328 13.7154 6.23051 13.8608 6.45002C14.0062 6.66953 14.2126 6.84174 14.4545 6.94545C14.7013 7.05437 14.9751 7.08686 15.2405 7.03873C15.5059 6.99061 15.7508 6.86408 15.9436 6.67545L15.9927 6.62636C16.1447 6.47422 16.3252 6.35352 16.5238 6.27118C16.7225 6.18883 16.9354 6.14644 17.1505 6.14644C17.3655 6.14644 17.5784 6.18883 17.7771 6.27118C17.9757 6.35352 18.1562 6.47422 18.3082 6.62636C18.4603 6.77834 18.581 6.95881 18.6634 7.15746C18.7457 7.35611 18.7881 7.56905 18.7881 7.78409C18.7881 7.99913 18.7457 8.21207 18.6634 8.41072C18.581 8.60937 18.4603 8.78984 18.3082 8.94182L18.2591 8.99091C18.0705 9.18374 17.9439 9.42865 17.8958 9.69406C17.8477 9.95948 17.8802 10.2332 17.9891 10.48V10.5455C18.0928 10.7874 18.265 10.9938 18.4845 11.1392C18.704 11.2846 18.9613 11.3626 19.2245 11.3636H19.3636C19.7976 11.3636 20.2138 11.536 20.5207 11.8429C20.8276 12.1498 21 12.566 21 13C21 13.434 20.8276 13.8502 20.5207 14.1571C20.2138 14.464 19.7976 14.6364 19.3636 14.6364H19.29C19.0267 14.6374 18.7695 14.7154 18.55 14.8608C18.3305 15.0062 18.1583 15.2126 18.0545 15.4545Z"
            stroke="#1570EF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
        <h2 className="transaction-title">{getTranslation('transactions', language)}</h2>
      </div>

      <div className="transaction-cont">
        <div className="transaction">
          {/* Right Sidebar - Tabs */}
          <div className="transaction-block__ui">
            <div className="ui-setting-block transaction-block__ui-set active-setting">
              <p className="ui-setting-block__title">{getTranslation('transactions', language)}</p>
            </div>
            <div
              className="ui-setting-block transaction-block__ui-set"
              onClick={handleWithdrawalGuide}
              style={{ cursor: 'pointer' }}
            >
              <p className="ui-setting-block__title">Withdrawal guide</p>
            </div>
            <div
              className="ui-setting-block transaction-block__ui-set"
              onClick={handleTotalSumTransactions}
              style={{ cursor: 'pointer' }}
            >
              <p className="ui-setting-block__title">Total sum transactions</p>
            </div>
          </div>

          {/* Main Content Block */}
          <div className="transaction__block">
            <div className="transaction-page-container">
              <div className="transaction-page-history">
                <table className="transaction-page_tab">
                  <thead className="transaction-page__header">
                    <tr className="transaction-page__header-title-block">
                      <th className="transaction-page__header-title">{getTranslation('externalKey', language)}</th>
                      <th className="transaction-page__header-title">{getTranslation('description', language)}</th>
                      <th className="transaction-page__header-title">{getTranslation('amount', language)}</th>
                      <th className="transaction-page__header-title">{getTranslation('dateTime', language)}</th>
                      <th className="transaction-page__header-title">{getTranslation('comment', language)}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedTransactions.length > 0 ? (
                      paginatedTransactions.map((transaction) => (
                        <tr key={transaction.id}>
                          <td>{transaction.externalKey}</td>
                          <td>{transaction.description}</td>
                          <td
                            style={{
                              color: transaction.amount.startsWith('+') ? '#10b981' : '#ef4444',
                              fontWeight: 600
                            }}
                          >
                            {transaction.amount}
                          </td>
                          <td>{transaction.dateTime}</td>
                          <td>{transaction.comment}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#98a2b3' }}>
                          No transactions found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="transaction-page__history__pagination">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className="transaction-page__history__previous"
                  onClick={handlePreviousPage}
                  style={{
                    cursor: currentPage > 1 ? 'pointer' : 'not-allowed',
                    opacity: currentPage > 1 ? 1 : 0.5,
                    pointerEvents: currentPage > 1 ? 'auto' : 'none'
                  }}
                >
                  <path
                    d="M15.8334 10H4.16675M4.16675 10L10.0001 15.8333M4.16675 10L10.0001 4.16666"
                    stroke={currentPage > 1 ? '#667085' : '#D0D5DD'}
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <p className="transaction-page__history__current-total">
                  {currentPage} / {totalPages}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className="transaction-page__history__next"
                  onClick={handleNextPage}
                  style={{
                    cursor: currentPage < totalPages ? 'pointer' : 'not-allowed',
                    opacity: currentPage < totalPages ? 1 : 0.5,
                    pointerEvents: currentPage < totalPages ? 'auto' : 'none'
                  }}
                >
                  <path
                    d="M4.16675 10H15.8334M15.8334 10L10.0001 4.16666M15.8334 10L10.0001 15.8333"
                    stroke={currentPage < totalPages ? '#667085' : '#D0D5DD'}
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="button">
        <button className="primary transaction__btn" type="button" onClick={handleUploadToEmail}>
          {getTranslation('uploadToEmail', language)}
        </button>
      </div>
    </div>
  );
};

export default Transactions;

